/**
 * Textos de Qualitat i APPCC (`es`): ajunta els fitxers de cada tall. Cablejat a `es.ts` amb un sol
 * `...qualityEs`; així cada tall edita només el seu fitxer.
 */

import { suppliersEs } from './suppliers.es.js';
import { trainingEs } from './training.es.js';
import { nonConformitiesEs } from './nonconformities.es.js';
import { selfChecksEs } from './selfchecks.es.js';
import { receptionEs } from './reception.es.js';
import { evidenceEs } from './evidence.es.js';
import { plantaEs } from './planta.es.js';

export const qualityEs = {
  ...suppliersEs,
  ...trainingEs,
  ...nonConformitiesEs,
  ...selfChecksEs,
  ...receptionEs,
  ...evidenceEs,
  ...plantaEs,
} as const;
